import { ApolloClient } from '@apollo/client/core'
import currentLoginSettings from '@/graphql/login-settings/currentLoginSettings.gql'
import updateLoginSettings from '@/graphql/login-settings/updateLoginSettings.gql'
import type { ApolloContext } from '@/services/types/Gql'
import type { Login, UpdateLoginSettings } from '@/types/generated'

interface ILoginSettingsGql {
  $apollo: ApolloClient<any>
  currentLoginSettings: (tenantId: string) => Promise<Login>
  updateTimezone: (tenantId: string, timezone: string) => Promise<UpdateLoginSettings>
  updateEmailNotifications: (tenantId: string, emailNotifications: boolean) => Promise<UpdateLoginSettings>
}

export default class LoginSettingsGql implements ILoginSettingsGql {
  $apollo: ApolloClient<any>
  constructor (context: ApolloContext) {
    this.$apollo = context.$apollo
  }

  async currentLoginSettings (tenantId: string) {
    return await this.$apollo.query({
      query: currentLoginSettings,
      variables: { tenantId },
      fetchPolicy: 'no-cache'
    }).then(res => res?.data.currentLoginSettings)
  }

  async updateTimezone (tenantId: string, timezone: string) {
    return await this.$apollo.mutate({
      mutation: updateLoginSettings,
      variables: { tenantId, timezone },
      fetchPolicy: 'no-cache'
    }).then(res => res?.data.updateLoginSettings)
  }

  async updateEmailNotifications (tenantId: string, emailNotifications: boolean) {
    return await this.$apollo.mutate({
      mutation: updateLoginSettings,
      variables: { tenantId, emailNotifications },
      fetchPolicy: 'no-cache'
    }).then(res => res?.data.updateLoginSettings)
  }
}
